<div id="preauthWrapper">
    <div class="preauth-dialog">
        <div id="divErrorGeneral">
            <h1>Oops, there's a problem</h1>
            <p>This is a little embarrassing, but we've encountered a system error and now we're stuck. Sorry about that.</p>
            <h2>So now what?</h2>
            <ol class="numbered">
                <li>Use your browser's back button to <strong>go back and try again</strong>.</li>
                <li>If that doesn't work, <strong>go to the <a href="/manager">home page</a></strong> and start over.</li>
                <li>If you're feeling motivated, <strong>submit a support ticket</strong> and let us know what happened so we can try to fix it.</li>
                <li>Or, call us at <strong>888-414-1988</strong> (or 617-600-0448) to speak to a support person.</li>
                <li>Please check <strong><a href="http://status.buildium.com" rel="external">status.buildium.com</a></strong> for the most up to date information.</li>
            </ol>
        </div>
    </div>
</div>
